export default __webpack_public_path__ + "Duly_loader_strokestofill.json";